'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var intervals = new Map();

var _generateId = function _generateId() {
  return "".concat(Date.now(), ":").concat(Math.floor(Math.random() * 1000000));
};
/**
 * Run a given task each {interval} ms
 *
 * @param {() => Promise} task
 * @param {number} interval
 * @param {string} id
 */


function _runPeriodically(_x, _x2, _x3) {
  return _runPeriodically2.apply(this, arguments);
}
/**
 * Asynchronous setInterval that is properly delayed using promises and can be delayed on boot.
 *
 * @param {() => Promise} task
 * @param {number} interval
 * @param {number} [delay = interval]
 * @returns {string}
 */


function _runPeriodically2() {
  _runPeriodically2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(task, interval, id) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!intervals.get(id)) {
              _context.next = 16;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return task();

          case 4:
            _context.next = 10;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            // Throw global context error if handler throws
            setTimeout(function () {
              throw _context.t0;
            }, 1);
            return _context.abrupt("break", 16);

          case 10:
            if (intervals.get(id)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("break", 16);

          case 12:
            _context.next = 14;
            return new Promise(function (resolve) {
              var _timeout = setTimeout(resolve, interval);

              intervals.set(id, _timeout);
            });

          case 14:
            _context.next = 0;
            break;

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6]]);
  }));
  return _runPeriodically2.apply(this, arguments);
}

function setDelayedInterval(task, interval, delay) {
  delay = delay || interval;

  var id = _generateId();

  var _timeout = setTimeout(function () {
    _runPeriodically(task, interval, id);
  }, delay);

  intervals.set(id, _timeout);
  return id;
}
/**
 * Clear delayed interval.
 *
 * @param {string} id
 */


function clearDelayedInterval(id) {
  var _timeout = intervals.get(id);

  if (_timeout) {
    clearTimeout(_timeout);
    intervals.delete(id);
  }
}

module.exports = {
  setDelayedInterval: setDelayedInterval,
  clearDelayedInterval: clearDelayedInterval
};